module.exports = __webpack_public_path__ + "img/mod_1.afb8f458.png";